// extracted by mini-css-extract-plugin
export default {"Box":"suggested-item-option-module__Box--vX3sU","Box_1":"suggested-item-option-module__Box_1--REa_Y","Text":"suggested-item-option-module__Text--ywOVd"};